import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Icons from 'react-icons/fa';
import Icon from '../components/Icon';

const NotFound: React.FC = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row>
        <Col md={12} className="text-center">
          <h1 className="display-1 fw-bold">404</h1>
          <h2 className="mb-4">Page Not Found</h2>
          <p className="lead mb-4">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          <Link to="/">
            <Button variant="primary" size="lg">
              <Icon icon={Icons.FaHome} className="me-2" /> Go Home
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound; 